export type TalentWorkRightReason =
  | "EU_EEA_CITIZEN" // EU- tai ETA-maan kansalaisuus
  | "WORK_RESIDENCE_PERMIT" // Työntekoon oikeuttava oleskelulupa
  | "RESIDENCE_PERMIT_NOT_REQUIRED"; // Työntekijä ei ulkomaalaislain tai kausityölain nojalla tarvitse oleskelulupaa

export interface UpdateTalentHrRepresentativeThunk {
  talentId: string;
  hrRepresentative: string;
  version: number;
  firstName: string;
  lastName: string;
}

export enum TalentStatus {
  INCOMPLETE = "INCOMPLETE", // Talent has registered, but profile is still incomplete
  NEW = "NEW", // Talent has registered and profile is completed for "interview process"
  INTERVIEW_PENDING = "INTERVIEW_PENDING", // Talent "interview process" is pending, for example Talent cannot be reached
  INTERVIEW = "INTERVIEW", // Talent is in "interview process"
  ACTIVE = "ACTIVE", // "interview process" is completed and Talent ready to work
  LATER = "LATER", // Talent not suitable at the given moment for working (some reason...)
  EMPLOYED_ELSEWHERE = "EMPLOYED_ELSEWHERE", // Talent has been employed by another employer
  NOT_EMPLOYED = "NOT_EMPLOYED", // Talent will not be employed
  DISABLED = "DISABLED", // Talent with this status is no longer using core (grace period has started)
  DEACTIVATED = "DEACTIVATED", // Talent with this status is no longer using core (grace period has ended)
}

export enum AssignmentType {
  LONG = "LONG",
  SHORT = "SHORT",
}

export interface TalentWorkingAreaForm {
  radiusInMeters: string;
}

export interface TalentFilterValues {
  status: string[];
  hrRepresentative: string[];
  talentTags: string[];
  areas: string[];
  orderQueues: string[];
  workTitleIds: string[];
  skillIds: string[];
  city: string[];
  certificateIds: string[];
  trainingIds: string[];
  languageSkillIds: string[];
  vehicleAvailable?: string;
  customerOrgId?: string;
  assignmentType?: string;
  assignmentActiveFrom?: string;
  assignmentActiveTo?: string;
  assignmentInactiveFrom?: string;
  assignmentInactiveTo?: string;
}

export const DEFAULT_TALENT_FILTER_VALUES: TalentFilterValues = {
  status: [],
  hrRepresentative: [],
  talentTags: [],
  areas: [],
  orderQueues: [],
  workTitleIds: [],
  skillIds: [],
  city: [],
  certificateIds: [],
  trainingIds: [],
  languageSkillIds: [],
};
